export const iconButtonVariantsSizeSmPx = "0.5rem"; // x-padding for small buttons
export const iconButtonVariantsSizeSmPy = "0.5rem"; // y-padding for small buttons
export const iconButtonVariantsSizeSmIconsDensity = "default";
export const iconButtonVariantsSizeSmIconsSize = "20dp";
export const iconButtonVariantsSizeMdPx = "0.625rem"; // x-padding for medium buttons
export const iconButtonVariantsSizeMdPy = "0.625rem"; // y-padding for medium buttons
export const iconButtonVariantsSizeMdIconsDensity = "default";
export const iconButtonVariantsSizeMdIconsSize = "20dp";
export const iconButtonVariantsSizeLgPx = "0.75rem"; // x-padding for large buttons
export const iconButtonVariantsSizeLgPy = "0.75rem"; // y-padding for large buttons
export const iconButtonVariantsSizeLgIconsDensity = "default";
export const iconButtonVariantsSizeLgIconsSize = "24dp";
export const iconButtonVariantsSizeXlPx = "1rem"; // x-padding for large buttons
export const iconButtonVariantsSizeXlPy = "1rem"; // y-padding for large buttons
export const iconButtonVariantsSizeXlIconsDensity = "default";
export const iconButtonVariantsSizeXlIconsSize = "24dp";
export const iconButtonVariantsStyleStandardSurfaceDefault = "rgba(76,76,76,0)"; // #4c4c4cx0
export const iconButtonVariantsStyleStandardSurfaceHover = "rgba(76,76,76,0.08)"; // #4c4c4cx0.08
export const iconButtonVariantsStyleStandardSurfaceActive = "rgba(76,76,76,0.12)"; // #4c4c4cx0.12
export const iconButtonVariantsStyleStandardSurfaceFocus = "rgba(76,76,76,0)"; // #4c4c4cx0
export const iconButtonVariantsStyleStandardSurfaceDisabled = "rgba(76,76,76,0)"; // #4c4c4cx0
export const iconButtonVariantsStyleStandardOnSurfaceDefault = "#4c4c4c";
export const iconButtonVariantsStyleStandardOnSurfaceDisabled = "rgba(76,76,76,0.24)"; // #4c4c4cx0.24
export const iconButtonVariantsStyleOutlinedSurfaceDefault = "rgba(76,76,76,0)"; // #4c4c4cx0
export const iconButtonVariantsStyleOutlinedSurfaceHover = "rgba(41,161,151,0.12)"; // #4c4c4cx0.08
export const iconButtonVariantsStyleOutlinedSurfaceActive = "rgba(41,161,151,0.24)"; // #4c4c4cx0.12
export const iconButtonVariantsStyleOutlinedSurfaceFocus = "rgba(76,76,76,0)"; // #4c4c4cx0
export const iconButtonVariantsStyleOutlinedSurfaceDisabled = "rgba(76,76,76,0)"; // #4c4c4cx0
export const iconButtonVariantsStyleOutlinedOnSurfaceDefault = "#00776f";
export const iconButtonVariantsStyleOutlinedOnSurfaceDisabled = "rgba(76,76,76,0.24)"; // #4c4c4cx0.24
export const iconButtonVariantsStyleOutlinedBorderWidth = "1px"; // 1px
export const iconButtonVariantsStyleTonalSurfaceDefault = "#d5efec";
export const iconButtonVariantsStyleTonalSurfaceHover = "#c3e9e4";
export const iconButtonVariantsStyleTonalSurfaceActive = "#b4e4dd";
export const iconButtonVariantsStyleTonalSurfaceFocus = "#c3e9e4";
export const iconButtonVariantsStyleTonalSurfaceDisabled = "#f1f1f1";
export const iconButtonVariantsStyleTonalOnSurfaceDefault = "#006a62";
export const iconButtonVariantsStyleTonalOnSurfaceDisabled = "#c6c6c6";
export const iconButtonVariantsStyleFilledSurfaceDefault = "#29a197";
export const iconButtonVariantsStyleFilledSurfaceHover = "#15938a";
export const iconButtonVariantsStyleFilledSurfaceActive = "#00857c";
export const iconButtonVariantsStyleFilledSurfaceFocus = "#15938a";
export const iconButtonVariantsStyleFilledSurfaceDisabled = "#c6c6c6";
export const iconButtonVariantsStyleFilledOnSurfaceDefault = "#fff";
export const iconButtonVariantsStyleFilledOnSurfaceDisabled = "#919191";
export const iconButtonBaseBorderRadius = "9999px";
export const iconButtonBaseFocusRingWidth = "0.25rem /4*3";
export const iconButtonBaseFocusRingColor = "#70c8be";
export const iconButtonSlotsBaseResizingW = "resizing-w-hug";
export const iconButtonSlotsBaseResizingH = "resizing-h-hug";
